import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
// Country flags as SVG (components/CountryFlag) — once, for the whole app.
import 'flag-icons/css/flag-icons.min.css';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
